import React from "react";

const BellSVG = ({ className }) => {
  return (
    <svg
      className={className}
      id="Bell"
      xmlns="http://www.w3.org/2000/svg"
      width="26.35"
      height="30.082"
      viewBox="0 0 26.35 30.082"
    >
      <path
        id="bell-solid"
        d="M13.174,30.082a3.762,3.762,0,0,0,3.762-3.76H9.412A3.762,3.762,0,0,0,13.174,30.082Zm12.668-8.8c-1.136-1.22-3.263-3.055-3.263-9.065A9.281,9.281,0,0,0,15.055,3.1V1.88a1.881,1.881,0,0,0-3.762,0V3.1a9.281,9.281,0,0,0-7.525,9.116c0,6.011-2.126,7.845-3.263,9.065A1.835,1.835,0,0,0,0,22.562a1.883,1.883,0,0,0,1.888,1.88H24.461a1.882,1.882,0,0,0,1.888-1.88A1.834,1.834,0,0,0,25.842,21.286Z"
        transform="translate(0.001)"
        fill="#292929"
      />
    </svg>
  );
};

export default BellSVG;
